'use strict';

var MarketProductGroupDowFilterFactory = function MarketProductGroupDowFilterFactory(DataFilterFactory) {
  function MarketProductGroupDowFilter() {
    this.sourceType = ['market-product-group', 'market'];
    this.filterType = 'dow';
  }
  MarketProductGroupDowFilter.constructor = MarketProductGroupDowFilter;
  MarketProductGroupDowFilter.prototype = Object.create(DataFilterFactory.prototype);
  MarketProductGroupDowFilter.prototype.groupBy = 'departureDateMomentDDD';
  return MarketProductGroupDowFilter;
};
MarketProductGroupDowFilterFactory.$inject = ['DataFilterFactory'];
module.exports = MarketProductGroupDowFilterFactory;